import { createSignal } from "solid-js";
import "./CustomConversion.scss";

const CustomConversion = () => {
  const [email, setEmail] = createSignal("");
  const [firstName, setFirstName] = createSignal("");
  const [lastName, setLastName] = createSignal("");
  const [phoneNumber, setPhoneNumber] = createSignal("");
  const [formSubmitted, setFormSubmitted] = createSignal(false);

  const [conversionTag, setConversionTag] = createSignal(
    "-tyzCKXJ0NEZEPWwkYQ-"
  );

  return (
    <div style="display:flex; flex-direction: column">
      <div className="CustomConversion">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            // gtag("set", "user_data", {
            //   email: email()
            // });
            // alert(`User Data Stored!\nEmail: ${email()}`);
          }}
        >
          <div>
            <label>Email:</label>
            <input
              type="email"
              id="email-input"
              value={email()}
              onInput={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button id="save-email-button" type="submit">
            Save
          </button>
        </form>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            // gtag("event", "conversion", {
            //   send_to: `AW-16651671669/${conversionTag()}`,
            // });
            setFormSubmitted(true);
          }}
        >
          <div>
            <label>Conversion Tag:</label>
            <input
              type="text"
              id="tagid-input"
              value={conversionTag()}
              onInput={(e) => setConversionTag(e.target.value)}
              required
            />
          </div>
          <button id="convert-button" type="submit">
            Convert
          </button>
        </form>
      </div>
      {formSubmitted() ? (
        <div style={{ margin: "5px auto", fontSize: "1.5rem", color: "white" }}>
          form submitted with {email()}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default CustomConversion;
